import { toastMessage } from "./toastMessage";

const events = {
  addItem_start: () => new CustomEvent("addItem:start"),
  addItem_end: (dat) => new CustomEvent("addItem:end", { detail: dat }),
  addItem_success: (dat) => new CustomEvent("addItem:success", { detail: dat }),
  addItem_failure: (dat) => new CustomEvent("addItem:failure", { detail: dat }),
};

export const postAddItem = (data, callback = () => {}) => {
  const { count, token, sku } = data;

  if (!token || !sku || !count) {
    throw new Error("Dataset not complete");
  }
  if (isNaN(parseInt(count))) {
    throw new Error("Count not a number");
  }

  document.dispatchEvent(events.addItem_start());

  fetch("/shop/addArtikel", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      action: "addArtikel",
      anzahl: parseInt(count),
      _token: token,
      artikelnummer: sku,
    }),
  })
    .then((response) => response.json())
    .then((dat) => {
      if (callback) {
        callback();
      }
      if (dat.success === true) {
        toastMessage(dat.message);
        document.dispatchEvent(events.addItem_success(dat));
        document.dispatchEvent(events.addItem_end(dat));
      }
    })
    .catch((error) => {
      if (callback) {
        callback();
      }
      console.error(error);
      document.dispatchEvent(events.addItem_failure());
      document.dispatchEvent(events.addItem_end());
    });
};
